<h2 mat-dialog-title class="dialog-title">Actualizar Viajes Abiertos</h2>
<mat-dialog-content class="dialog-content">
  <p class="dialog-description">
    Se detectó un cambio de Usuario o Responsable para la ruta <strong>{{ data.routeName }}</strong>.
    Seleccione los viajes abiertos a los que desea replicar este cambio:
  </p>

  <div class="trips-table">
    <table mat-table [dataSource]="dataSource" class="w-full">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="w-12 text-center">
          <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="w-12 text-center">
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Número de viaje -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>Nº Viaje</th>
        <td mat-cell *matCellDef="let element" class="font-semibold text-sm">
          {{ element.id }}
        </td>
      </ng-container>

      <!-- Período de fecha (Inicio y Fin Teóricos) -->
      <ng-container matColumnDef="dateRange">
        <th mat-header-cell *matHeaderCellDef>Período de Fecha</th>
        <td mat-cell *matCellDef="let element" class="text-sm">
          <span>{{ element.dateHourStartTeoric | date: 'dd/MM/yyyy HH:mm' }}</span> - 
          <span>{{ element.dateHourEndTeoric | date: 'dd/MM/yyyy HH:mm' }}</span>
        </td>
      </ng-container>

      <!-- Estado -->
      <ng-container matColumnDef="statusTripId">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let element" class="text-sm">
          {{ getStatusLabel(element.statusTripId) }}
        </td>
      </ng-container>

      <!-- Usuario actual -->
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef>Usuario Anterior</th>
        <td mat-cell *matCellDef="let element" class="text-sm">
          {{ element.user?.user_login?.username ?? '-' }}
        </td>
      </ng-container>

      <!-- Responsable actual -->
      <ng-container matColumnDef="responsible">
        <th mat-header-cell *matHeaderCellDef>Responsable Anterior</th>
        <td mat-cell *matCellDef="let element" class="text-sm">
          {{ element.responsibleBusinessPartner?.name ?? '-' }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-100"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)" class="cursor-pointer hover:bg-gray-50 border-b"></tr>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
  <button mat-button type="button" (click)="onCancel()">No actualizar viajes</button>
  <button mat-flat-button color="primary" type="button" (click)="onConfirm()" [disabled]="selection.selected.length === 0">
    Actualizar Seleccionados ({{ selection.selected.length }})
  </button>
</mat-dialog-actions>
